"use client"

import { useMemo, useState } from "react"
import { parseAsBoolean, parseAsString, useQueryState } from "nuqs"

import { Module } from "../types"

export const useModules = (modules: Module[]) => {
  const [selectedCardId, setSelectedCardId] = useQueryState(
    "selectedModule",
    parseAsString.withDefault(modules[0]?.id || "")
  )
  const [showConfig, setShowConfig] = useQueryState(
    "showConfig",
    parseAsBoolean.withDefault(false)
  )
  const [searchQuery, setSearchQuery] = useState("")

  const allTags = useMemo(() => {
    const tagsSet = new Set<string>()
    modules.forEach((module) => {
      module.tags.forEach((tag) => tagsSet.add(tag.name))
    })
    return Array.from(tagsSet)
  }, [modules])

  const [selectedTags, setSelectedTags] = useState<string[]>(allTags)

  const handleTagChange = (tagName: string) => {
    setSelectedTags((prev) =>
      prev.includes(tagName)
        ? prev.filter((t) => t !== tagName)
        : [...prev, tagName]
    )
  }

  const filteredModules = useMemo(() => {
    return modules
      .filter((module) =>
        module.title.toLowerCase().includes(searchQuery.toLowerCase())
      )
      .filter(
        (module) =>
          selectedTags.length === 0 ||
          module.tags.some((tag) => selectedTags.includes(tag.name))
      )
  }, [searchQuery, selectedTags, modules])

  const selectedModule = modules.find((m) => m.id === selectedCardId) || null

  const onCardClick = (id: string) => {
    if (selectedCardId !== id) {
      setShowConfig(false)
    }
    if (id !== selectedCardId) {
      setSelectedCardId(id)
    }
  }

  const onForgeClick = () => {
    setShowConfig(!showConfig)
  }

  return {
    selectedCardId,
    setSelectedCardId,
    selectedModule,
    showConfig,
    setShowConfig,
    onForgeClick,
    onCardClick,
    searchQuery,
    setSearchQuery,
    allTags,
    selectedTags,
    handleTagChange,
    filteredModules,
  }
}
